import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ManualSocialEntry from "./ManualSocialEntry";
import ManualChannelConnection from "../../../components/Icons/ManualChannelConnection";
import { LockIcon } from "lucide-react";

const CustomBtnTooltip = ({ children, position }) => {
  return (
    <span
      className={`text-[13px] tw-hide group-hover:inline-block w-full absolute top-12 bg-white rounded-lg border border-light-border p-4 text-left space-y-3 ${
        position === "left" ? "left-0" : "right-0"
      }`}
    >
      {children}
    </span>
  );
};

const btnClass =
  "w-full flex items-center justify-start h-10 px-3 py-1 text-xs font-medium gap-2 rounded-lg group text-primary-600 transition-all";

const Step = ({
  prevStep,
  nextStep,
  onUserSignUpByStep,
  currentStep,
  totalSteps,
}) => {
  const [tab, setTab] = useState("MANUAL_ENTRY");
  const [currentHovered, setCurrentHovered] = useState(null);

  const [manualConnectedChannels, setManualConnectedChannels] = useState([]);
  const fetchingUserRegistration = useSelector(
    (state) => state?.signup?.fetchingUserRegistration || false
  );
  const validatedChannels = useSelector(
    (state) => state?.signup?.rewardsUser || []
  );

  useEffect(() => {
    if (!fetchingUserRegistration) {
      // Channels connected manually
      const filterNonManualChannels =
        validatedChannels?.social_channels?.filter((c) => c?.phyllo !== true);
      setManualConnectedChannels(filterNonManualChannels);
    }
  }, [fetchingUserRegistration, validatedChannels]);

  return (
    <div className="mx-auto w-full lg:w-[480px]">
      <ManualSocialEntry
        prevStep={prevStep}
        nextStep={nextStep}
        currentStep={currentStep}
        totalSteps={totalSteps}
        onUserSignUpByStep={onUserSignUpByStep}
        connectedChannels={manualConnectedChannels}
      />
    </div>
  );
};

export default Step;
